export const FILE_TYPES_EXTENSIONS = [
	".pdf",
	".docx",
	".docm",
	"dotx",
	"dotm",
	".xlsx",
	".xlsm",
	".xslx",
	".zip",
	".exe",
	".txt",
	".html",
	".json",
];
export const FILE_TYPES = { FILE: "FILE", FOLDER: "FOLDER", UNSUPPORTED: "UNSUPPORTED" };

export const DISPLAYABLE_FILE_TYPES = {
	DOC: { extension: ".doc", displayable: true },
	DOCX: { extension: ".docx", displayable: true },
	RTF: { extension: ".rtf", displayable: true },
	ODT: { extension: ".odt", displayable: true },
	XLS: { extension: ".xls", displayable: true },
	XLSX: { extension: ".xlsx", displayable: true },
	XLSM: { extension: ".xlsm", displayable: true },
	PDF: { extension: ".pdf", displayable: true },
	PPT: { extension: ".ppt", displayable: true },
	PPTX: { extension: ".pptx", displayable: true },
	EML: { extension: ".eml", displayable: true },
	ZIP: { extension: ".zip", displayable: false },
	HIDDEN_FILE: { extension: null, displayable: false },
	UNSUPPORTED: { extension: null, displayable: false },
} as const;

export type DisplayableFileTypeName = keyof typeof DISPLAYABLE_FILE_TYPES;
